export { default } from './FaqAccordion';
